"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableRowElementCheckbox = void 0;
var React = require("react");
var tableRowElement_1 = require("./tableRowElement");
var deadline_1 = require("../editableList/deadline");
var editableCell_1 = require("../editableList/editableCell");
var TableRowElementCheckbox = function (props) {
    var tableDataBefore;
    var colspan = 1;
    switch (props.label_props.elementType) {
        case tableRowElement_1.ElementTypes.risk:
            tableDataBefore = null;
            colspan = 3;
            break;
        case tableRowElement_1.ElementTypes.control:
            tableDataBefore = (React.createElement("td", null, "\u00A0"));
            colspan = 2;
            break;
        case tableRowElement_1.ElementTypes.action:
            tableDataBefore = (React.createElement(React.Fragment, null,
                React.createElement("td", null, "\u00A0"),
                React.createElement("td", null, "\u00A0")));
            break;
        default:
            throw new Error("Invalid elementType");
    }
    return (React.createElement(React.Fragment, null,
        tableDataBefore,
        props.showCheckbox && (React.createElement("td", { className: props.colorClass },
            React.createElement("input", { type: "checkbox", value: props.value, name: props.name, id: props.id, disabled: props.disabled, checked: props.isChecked && props.isChecked(props.id, props.value, props.disabled), onChange: props.inputChangeHandler }))),
        React.createElement("td", { className: props.colorClass, colSpan: colspan, scope: "row" }, props.label_props.number),
        React.createElement("td", { className: props.colorClass }, props.label_props.title),
        props.label_props.deadline ?
            React.createElement("td", { className: props.colorClass },
                React.createElement(deadline_1.default, { date: props.label_props.deadline, urgency: editableCell_1.EditableDate.computeUrgency(props.label_props.deadline) }))
            :
                React.createElement("td", { className: props.colorClass }, "\u00A0"),
        React.createElement("td", { className: props.colorClass }, props.label_props.status_display),
        React.createElement("td", { className: props.colorClass }, props.label_props.owner)));
};
exports.TableRowElementCheckbox = TableRowElementCheckbox;
